import { Modal, TouchableOpacity, View } from "react-native";
import { DatePicker, PickerSelectDate } from "../components/picker/DataPicker";
import React from "react";
import RNDateTimePicker from "@react-native-community/datetimepicker";

type DatePickerDialogType = {
  visible: boolean,
  defValue: string
  onComplete: (date: PickerSelectDate) => void
  setVisible: (vis: boolean) => void
}

export const DatePickerDialog = ({ visible, setVisible, onComplete, defValue }: DatePickerDialogType) => {
  const dismiss = () => {
    setVisible(false);
  };

  return (
    <Modal
      transparent={true}
      visible={visible}
      onRequestClose={dismiss}
      animationType="slide"
      statusBarTranslucent={true}>
      <TouchableOpacity
        activeOpacity={1}
        onPress={dismiss}
        style={{ backgroundColor: "rgba(0,0,0,0.5)", flex: 1 }}>
        <View style={{ position: "absolute", bottom: 0, start: 0, end: 0 }}>
          <DatePicker
            defValue={defValue}
            onComplete={(type) => {
              onComplete(type);
              dismiss();
            }}
            onCancel={dismiss}
            minYear={1900}
          />
        </View>
      </TouchableOpacity>
    </Modal>
  );
};